import request from '../api/request'

// 分页查询考生组和考生信息
export function queryGroupsAndUser(param) {
  return request({
    url: '/group/queryGroupsAndUser',
    method: 'get',
    params: param
  })
}

// 新增考试组
export function createExamineeGroup(data) {
    return request({
      url: '/group/add',
      method: 'post',
      data: data
    })
}

// 修改考试组
export function modifyExamineeGroup(data) {
    return request({
      url: '/group',
      method: 'put',
      data: data
    })
}
// 删除考试组
export function deleteGroups(groupIds) {
    return request({
      url: '/group/'+ groupIds,
      method: 'delete',
    })
}

